<template>
<v-card>
  <camera-thumb :src="imageUrl" :faces="[face]" clickable @click="$emit('edit',face)"></camera-thumb>
</v-card>
</template>

<script>
import CameraThumb from './CameraThumb'

export default {
  name: 'FaceLabelingItem',
  props: {
    face: {
      type: Object,
      required: true
    }
  },
  components: {
    'camera-thumb': CameraThumb
  },
  data() {
    return {
      imageUrl: null
    }
  },
  watch: {
    face(val) {
      this.imageUrl = `${val.imageUrl}&${new Date().getTime()}`;
    }
  },
  mounted() {
    this.imageUrl = this.face.imageUrl;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cast/FaceLabelingItem.vue